// General
import React from 'react';
import {
    Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import BaseFareForm from '../BaseFareForm/BaseFareForm';

import { closeBaseFareModal } from '../../../../actions/siteadmin/modalActions';

import s from './BaseFareModal.css';

const BaseFareModal = ({ closeBaseFareModal, baseFareModal, title, categories, subCatgeoryChange }) => {
    return (
        <Modal show={baseFareModal} onHide={closeBaseFareModal} dialogClassName='commonModalContainer'>
            <Modal.Header closeButton className='commonModalHeader'>
                <Modal.Title>
                    <div className="commonModalTitle">{title}</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='commonModalBody'>
                <BaseFareForm categories={categories} subCatgeoryChange={subCatgeoryChange} />
            </Modal.Body>
        </Modal>
    );
};

const mapState = (state) => ({
    baseFareModal: state.adminModalStatus.baseFareModal,
    title: state.adminModalStatus.title
});

const mapDispatch = {
    closeBaseFareModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BaseFareModal)));

